import { render, staticRenderFns } from "./cadcotacoes.vue?vue&type=template&id=77128136&"
import script from "./cadcotacoes.vue?vue&type=script&lang=js&"
export * from "./cadcotacoes.vue?vue&type=script&lang=js&"
import style0 from "./cadcotacoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports